module.exports = __webpack_public_path__ + "static/media/shape-icon-empty.a3dbacd1.png";